import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompleteMedicalCareStruct } from '../../services/structs/orchestrator-patient/complete-medical-care.struct';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { SadtStatusEnum } from '../../enum/sadt-status.enum';
import { SadtGroupStruct } from '../../services/structs/medical-record/sadt-group.struct';
import { ExamsSuspensionCofirmModalComponent } from '../exams-suspension-cofirm-modal copy/exams-suspension-cofirm-modal.component';

@Component({
    selector: 'app-exams-suspension-modal',
    templateUrl: './exams-suspension-modal.component.html',
    styleUrls: ['./exams-suspension-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExamsSuspensionModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<ExamsSuspensionModalComponent>,
  ) { }

  public sadtStatusEnum: typeof SadtStatusEnum = SadtStatusEnum;

  public isLoading: boolean = true;
  public isHistory: boolean = false;

  public medicalCare: CompleteMedicalCareStruct[] = [];
  public listExamsToSuspend: SadtGroupStruct[] = [];

  public idCurrentMedicalCare: number;//if history

  ngOnInit(): void {
    if(this.data){
      this.medicalCare = this.data.medicalCare;
      this.isHistory = this.data.isHistory;
      this.idCurrentMedicalCare = this.data.idCurrentMedicalCare;
      if(this.data.listExamsToSuspend)
        this.listExamsToSuspend = this.data.listExamsToSuspend;
    }

    this.isLoading = false;
  }

  close() {
    this.matDialogRef.close({
      listExamsToSuspend: this.listExamsToSuspend,
    });
  }

  cancel() {
    const dialogRef = this.dialog.open(AlertModalComponent, {
      data: {
        isTwoButtonsModal: true,
        hasImage: true,
        title: 'Aviso',
        description: `O cancelamento da suspensão removerá as alterações feitas e esta ação é irreversível. Deseja continuar?`
      },
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm){
          this.listExamsToSuspend = [];
          this.close();
        }
      }
    });
  }

  validateActionSuspendedExam(idSadtGroup: number): boolean {
    return this.listExamsToSuspend.find(x => x.idSadtGroup == idSadtGroup) ? true : false;
  }

  messageEmptyListExam() : string {
    return this.isHistory ? 'Não há exames suspensos neste atendimento' : 'Não há exames em aberto para este atendimento';
  }

  openExamModal(exam: any) {
    const dialogRef = this.dialog.open(ExamsSuspensionCofirmModalComponent, {
      data: {
        examToSuspend: exam,
      },
      panelClass: 'prescriptions-suspension-confirm'
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.examToSuspend) {
          this.listExamsToSuspend.push(result.examToSuspend);
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

}
